











































import { Component, Vue, Watch } from 'vue-property-decorator';
import { User } from '@/@types';

@Component
export default class ProfilePage extends Vue {
  /* ------------------------------------
  => Local State Declaration
  ------------------------------------ */
  fav: boolean = false;
  lang: boolean = false;

  /* ------------------------------------
  => Setter and Getter
  ** (Adopt store variables to local state)
  ------------------------------------ */
  get profile(): User {
    return this.$store.state.user.currentUser;
  }

  get languageSetting(): ProfilePage {
    return this.$store.state.i18n.languageSetting.profilePage;
  }

  /* ------------------------------------
  => Mounted (Lifecycle)
  ------------------------------------ */
  async mounted(): Promise<void> {
    this.lang = this.$store.state.i18n.isBahasaIndonesia;
  }

  /* ------------------------------------
  => Methods
  ------------------------------------ */
  changeLanguage(): void {
    this.$store.dispatch('i18n/changeLanguage', this.$store.state.i18n.isBahasaIndonesia ? 'EN' : 'ID');
  }

  /* ------------------------------------
  => Watcher
  ------------------------------------ */
  @Watch('$store.state.i18n.isBahasaIndonesia')
  async handleOnLanguageChange(newValue: boolean): Promise<void> {
    this.lang = newValue;
  }
}
